module.exports = __webpack_public_path__ + "assets/devices/Smart-CO-Sensor-05327b52ccae8e2e05e044946ddd1a30.svg";